'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _utilsFont = require('./utils/font');

var _utilsFont2 = _interopRequireDefault(_utilsFont);

var _utilsBorder = require('./utils/border');

var _utilsBorder2 = _interopRequireDefault(_utilsBorder);

var _utilsBackgroundStyle = require('./utils/backgroundStyle');

var _utilsBackgroundStyle2 = _interopRequireDefault(_utilsBackgroundStyle);

var _HtmlContent = require('./HtmlContent');

var _HtmlContent2 = _interopRequireDefault(_HtmlContent);

var Box = function Box(props) {

	var style = {};

	//size
	if (!!props.height) style.height = props.height;
	if (!!props.width) style.width = props.width;

	//text style
	var pStyle = { position: 'relative' };

	var size = props.padding || {};
	pStyle.paddingTop = size.top;
	pStyle.paddingRight = size.right;
	pStyle.paddingBottom = size.bottom;
	pStyle.paddingLeft = size.left;

	//background style
	var bgStyle = { width: '100%', height: '100%', position: 'absolute' };
	if (props.background !== undefined) bgStyle = _lodash2['default'].extend(bgStyle, (0, _utilsBackgroundStyle2['default'])(props.background));

	//border
	(0, _utilsBorder2['default'])(bgStyle, props.border);

	//clipPath
	if (!!props.clipPath) {
		bgStyle.clipPath = props.clipPath;
		bgStyle.WebkitClipPath = props.clipPath;
	}

	return _react2['default'].createElement(
		'div',
		{ style: style },
		_react2['default'].createElement('div', { style: bgStyle }),
		_react2['default'].createElement(_HtmlContent2['default'], { style: pStyle, content: props.content, font: props.font })
	);
};
Box.defaultProps = { content: 'type your content' };
exports['default'] = Box;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/widgets/HtmlBox.js
 ** module id = 2217
 ** module chunks = 0
 **/